<script>
// import Fade from 'linna/components/Fade'

export default {
  name: 'MapPoint',

  // components: {
  //   Fade,
  // },

  props: {
    cell: {
      type: Object,
      required: true
    }
  }

}
</script>

<template>
  <div class="c-map-point">

    <!-- Radio transmission in this cell -->
    <template v-if="cell.radioTransmissions">

      <div
        v-for="radioTransmission in cell.radioTransmissions"
        :key="radioTransmission.id"
        class="c-map-point-transmission"
      >
        <div class="c-map-point-transmission-content">
          <!-- :style="{
            width: ((radioTransmission.range * 2 * cellWidth) + cellWidth) + 'rem',
            height: ((radioTransmission.range * 2 * cellWidth) + cellWidth) + 'rem'
          }" -->
          <div
            class="c-map-point-transmission-blip"
          />
        </div>
      </div>

    </template>

  </div>
</template>

<style lang="scss">

.c-map-point {
  @include relative;
}

// Radio transmission

.c-map-point-transmission {
  @include fill;
}

.c-map-point-transmission-content {
  @include fill-relative;
}

.c-map-point-transmission-blip {
  @include keep-full-center;
  @include round;
  width: 200%;
  height: 200%;
  background-color: translucent($green);

  animation-name: flicker-subtle;
  animation-duration: 2150ms;
  animation-iteration-count: infinite;

  &:after {
    @include keep-full-center;
    @include round;
    @include block;
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    background-color: $green;
  }

}

</style>
